import { useEffect, useMemo, useRef, useState } from 'react';
import { useFollowedShefsQuery } from 'src/gqlReactTypings.generated.d';
import { UseIsFollowingProps } from '../types';

/**
 * Hook to check if following given shef.
 */
export const useIsFollowing = (props: UseIsFollowingProps) => {
  const { shefId } = props;
  const animatedTimeout = useRef<number>();

  const [isFollowing, setIsFollowing] = useState(false);
  const [isAnimated, setIsAnimated] = useState(false);

  const { data, loading: loadingFollows, refetch } = useFollowedShefsQuery();
  const followedShefs = useMemo(() => data?.me?.followedShefs ?? [], [data?.me?.followedShefs]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!loadingFollows && isLoading) {
      const followedShefIds = Object.values(followedShefs).map((shef) => shef?.id ?? '');
      const isFollowingShef = followedShefIds.includes(shefId);
      setIsFollowing(isFollowingShef);
      setIsLoading(false);

      // eslint-disable-next-line functional/immutable-data -- Clearing timeout
      animatedTimeout.current = window.setTimeout(() => setIsAnimated(true), 1000);
    }
  }, [loadingFollows, followedShefs, shefId, isFollowing, isLoading]);

  useEffect(
    () => () => {
      clearTimeout(animatedTimeout.current);
    },
    []
  );

  return {
    followedShefs,
    isAnimated,
    isFollowing,
    isLoading,
    refetch: () => refetch(),
    setIsFollowing,
    shef: followedShefs.find((shef) => shef?.id === shefId),
  };
};
